import { useAppState } from "AppState";
import React from "react";
import { Routes } from "router";

import OnboardingContainer from "screens/Onboarding/Onboarding.container";
import TermsAndConditions from "screens/Onboarding/WelcomeBoard/TermsAndConditions/TermsAndConditions";
import TermsAndConditionsVerde from "screens/Onboarding/WelcomeBoard/TermsAndConditions/TermsAndConditionsVerde";
import useReactRouter from "use-react-router";

export default (): JSX.Element => {
  const { locationName, tenantId, verdeTenantIds } = useAppState();
  const { history } = useReactRouter();
  const {
    logoutCustomer,
    signInNewCustomer,
    signUpCustomer
  } = OnboardingContainer.useContainer();
  const call = signUpCustomer();

  const handleOnSubmit = async () => {
    // TODO: add types
    const { data } = await call.signUpCustomer();
    console.log(data);
    if (data) {
      signInNewCustomer(data.signUpCustomer);
    }
  };

  const goToSignUp = () => {
    logoutCustomer();
    history.push(Routes.Home);
  };

  const toc = (
    <TermsAndConditions
      locationName={locationName}
      nextStep={handleOnSubmit}
      previousStep={goToSignUp}
    />
  );

  const tocVerde = (
    <TermsAndConditionsVerde
      tenantId={tenantId}
      locationName={locationName}
      nextStep={handleOnSubmit}
      previousStep={goToSignUp}
    />
  );

  const tocToServe = verdeTenantIds.includes(tenantId) ? tocVerde : toc;

  return tocToServe;
};



// WEBPACK FOOTER //
// ./src/screens/Onboarding/NewAtLocation/NewAtLocationTcpaAcknowledgement.tsx